class ProductBoxSummary extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.handleProductSelect = this.handleProductSelect.bind(this);
    this.section?.addEventListener('shopify:product:select', this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('shopify:product:select', this.handleProductSelect);
  }

  handleProductSelect(event) {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise?.then(({ detail }) => {
      if (!detail?.resource || detail.productId !== this.dataset.productId) return;
      this.update(detail.resource);
    });
  }

  update(variant) {
    const options = Array.isArray(variant.options) ? variant.options : [];
    const flavor = options[0] || this.dataset.flavor || '';
    const packageLabel = options[1] || this.dataset.package || '';
    const packageCount = Number.parseInt(packageLabel.match(/\d+/)?.[0] || '', 10);
    const portions = packageCount > 1 ? Math.floor(packageCount / 2) : packageCount;
    const flavorParts = flavor.split(/\s*\+\s*/).map((part) => part.trim()).filter(Boolean);
    const text =
      portions > 0 && flavorParts.length > 1
        ? `Kutuda: ${portions} × ${flavorParts[0]}, ${portions} × ${flavorParts[1]}`
        : `Kutuda: ${packageLabel} · ${flavor}`;

    const summaryText = this.querySelector('[data-box-summary-text]');
    if (summaryText) summaryText.textContent = text;
    this.dataset.flavor = flavor;
    this.dataset.package = packageLabel;
  }
}

if (!customElements.get('product-box-summary')) {
  customElements.define('product-box-summary', ProductBoxSummary);
}
